var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.element.settings.description)?_c('p',{staticClass:"form-description fw-normal text-break p-0 m-0",style:(_vm.labelStyle),attrs:{"id":`description-${_vm.element.id}`},domProps:{"innerHTML":_vm._s(_vm.element.settings.description)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }